"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MonthlyCharges_1 = require("./MonthlyCharges");
exports.default = MonthlyCharges_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/common/MonthlyCharges/index.js
// module id = 779
// module chunks = 8